export const getModuleColor = (moduleName) => {
    switch (moduleName) {
        case "CORE": return "#2bb673"
        case "ADMIN": return "orange"
        case "HR": return "gold"
        case "WHISTLE": return "orange"
        case "HEALTH": return "lightgreen"
        case "SAFETY": return "tomato"
        case "AI": return "#d731a3"
        default: return "#FFFFFF"
    }
}